import { ColumnsType } from "antd/es/table";
import { IExportData } from "@/pages/export-list/types";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { ModuleType } from "@/pages/operate-record/types";
import { Tooltip } from "@renderbus/ui";

const t = getTranslateNsT("center");
const commonT = getTranslateNsT("common");
const recordT = getTranslateNsT("operateRecord");

export const columns: ColumnsType<IExportData> = [
  {
    title: t("user_operate_record_index"),
    dataIndex: "taskName",
    render: (_, _r, r) => r + 1,
  },
  {
    title: t("user_operate_record_user_name"),
    dataIndex: "userName",
  },
  {
    title: t("user_operate_record_module_type"),
    dataIndex: "taskType",
    render: (row) => {
      return recordT(`user_operate_record_module_${row}`);
    },
  },
  {
    title: t("render_table_sort_id"),
    dataIndex: "taskIds",
    render: (value) => {
      const taskIds = JSON.parse(value) as string[] | null | undefined;
      const fullText = taskIds?.join(",") ?? "";
      if (!taskIds || taskIds.length <= 3) {
        return fullText;
      }
      const displayText = `${taskIds.slice(0, 3).join(",")}...`;
      return (
        <Tooltip
          placement="top"
          title={fullText}
          color="#202124"
          triggerBody={
            typeof document !== "undefined" ? document.body : undefined
          }
          tooltipText={<span>{displayText}</span>}
        />
      );
    },
  },
  {
    title: t("user_operate_record_operate_type"),
    dataIndex: "buttonName",
    render: (row) => {
      return recordT(`monitor_log_${row}`);
    },
  },
  {
    title: t("operation_detail"),
    dataIndex: "details",
    width: 500,
    render: (_: any, row: any) => {
      const { taskType, details } = row;
      if (taskType === ModuleType.UserAuth) {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a style={{ color: "var(--main-color)" }}>{t(`user_auth_details`)}</a>
        );
      }
      let text = details;
      const formatManageDetail = (details: string) => {
        const obj = JSON.parse(details);
        const list: { label: string; value: string | number; key: string }[] =
          [];
        // 定义字段顺序
        const fieldOrder = [
          "desktopId",
          "modelName",
          "mirrorImageName",
          "systemDiskSize",
          "billingMethod",
          "startupNumber",
          "charterFlightHours",
          "remarks",
        ];
        Object.entries(obj).forEach(([key, value]) => {
          if (key === "packageFlightHours") {
            return;
          }
          // 计费方式
          if (key === "billingMethod") {
            const defaultText = recordT(`monitor_log_billingMethod_${value}`);
            // 如果是包机，显示包机时长
            if (value === 1 && obj.packageFlightHours) {
              const days =
                obj.packageFlightHours % 24 === 0
                  ? obj.packageFlightHours / 24
                  : (obj.packageFlightHours / 24).toFixed(2);
              value = `${defaultText} ${days} ${commonT("common_day")}`;
            } else {
              value = defaultText;
            }
          }
          if (key === "remarks") {
            value = value === "" ? commonT("common_none") : value;
          }
          list.push({
            label: recordT(`monitor_log_${key}`),
            value: value as string | number,
            key,
          });
        });

        // 按照指定顺序排序
        list.sort((a, b) => {
          const indexA = fieldOrder.indexOf(a.key);
          const indexB = fieldOrder.indexOf(b.key);
          // 如果字段不在顺序列表中，放在最后
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });

        return list
          .filter(
            (item) =>
              item.value !== "" &&
              item.value !== undefined &&
              item.value !== null
          )
          .map((item) => `${item.label}: ${item.value}`)
          .join("\n");
      };
      if (taskType === ModuleType.CloudProduce) {
        text = formatManageDetail(details);
      }
      return (
        <Tooltip
          placement="topLeft"
          getPopupContainer={() => document.body}
          title={
            <span
              style={{
                color: "#202124",
                fontSize: "12px",
                whiteSpace: "pre-wrap",
              }}
            >
              {text}
            </span>
          }
          tooltipText={
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "500px",
                lineHeight: "18px",
              }}
            >
              {text}
            </div>
          }
        />
      );
    },
  },
  {
    title: t("user_operate_record_operate_origin"),
    dataIndex: "operateSource",
    render: (row) => {
      return recordT(`monitor_log_operate_origin_${row}`);
    },
  },
  {
    title: t("user_operate_record_channel"),
    dataIndex: "channel",
    render: (row) => {
      return recordT(`monitor_log_channel_${row}`);
    },
  },
  {
    title: t("user_operate_record_create_time"),
    dataIndex: "createTime",
  },
];
